jQuery(function ($) {


    var height = $(window).height();
    var header = $('.l-header');
    var headerHeight = header.outerHeight();


    
    // ================================================================
    // サイズガイド：モーダル
    // ================================================================
    // $('.js-modal').on('click', function () {
    //     $('.p-modal').fadeIn();
    //     $('.p-modal__close , .p-modal__bg').click(function () {
    //         $('.p-modal').fadeOut();
    //     });
    // });
    
        // ================================================================
    // 商品画像カルーセル
    // ================================================================

    // const mySwiper_thumb = new Swiper('.p-product__thumb-swiper', {
    //     speed: 600,
    //     centerInsufficientSlides: true,
    //     slidesPerView: 7,
    //     spaceBetween: 4,
    //     breakpoints: {
    //         769: {
    //             slidesPerView: 8,
    //             spaceBetween: 11,
    //         }
    //     },
    // });

    // const mySwiper_main = new Swiper('.p-product__main-swiper', {
    //     speed: 600,
    //     centeredSlides: false,
    //     slidesPerView: 1,
    //     allowTouchMove: true,
    //     pagination: {
    //         el: '.swiper-pagination', // ページネーション要素のクラス
    //         clickable: true, // クリックによるスライド切り替えを有効にする
    //         type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    //     },
    //     navigation: {
    //         nextEl: '.p-product__main-swiper .swiper-button-next',
    //         prevEl: '.p-product__main-swiper .swiper-button-prev',
    //     },
    //     thumbs: {
    //         swiper: mySwiper_thumb,
    //     },
    //     breakpoints: {
    //         1680: {
    //             slidesPerView: 2, // 1680px以上で変更される
    //         }
    //     }
    // });

    // ================================================================
    // ページ内アンカーのページ付きリンクへのスムーススクロール
    // ================================================================
    function smoothScroll(){
        const links = document.querySelectorAll('a[href^="#"]');
    
        links.forEach((link) =>{
        link.addEventListener('click', (e) => {
            e.preventDefault();
            
            const href = link.getAttribute('href');
            const targetSection = document.querySelector(href);
            const sectionTop = targetSection.getBoundingClientRect().top;
            const currentPos = window.scrollY;
            const gap = 170;
            const target = sectionTop + currentPos - gap;
    
            window.scrollTo({
            top: target,
            behavior: 'smooth',
            });
        });
        });
    }
    smoothScroll();
    document.addEventListener("shopify:section:load", function () {
        smoothScroll();
    });
    
    // ================================================================
    // アコーディオン
    // ================================================================
    $(function () {
        $(".js-accordion-title").on("click", function () {
            $(this).next().slideToggle(300);
            $(this).toggleClass("open", 300);
        });
    });
    document.addEventListener('shopify:section:load', (event) => {
        $(function () {
            $(".js-accordion-title").each(function () {
                var $title = $(this);
                var $body = $title.next(".c-accordion__body");
    
                // Shopifyカスタマイズ画面で選択されたブロックかどうかを判定
                if ($title.closest('.p-accordion___item').is(event.target)) {
                    $body.show(); // 初期状態で開く
                    $title.addClass("open"); // クラスを付与
                } else {
                    $body.hide(); // それ以外は閉じる
                    $title.removeClass("open");
                }
    
                // クリック時のトグル動作
                $title.off("click").on("click", function () {
                    $(this).next().slideToggle(300);
                    $(this).toggleClass("open", 300);
                });
            });
        });
    });
    
    // Shopifyのカスタマイズ画面でブロックが選択されたときに開く
    document.addEventListener('shopify:block:select', function(event) {
        $(".js-accordion-title").each(function () {
            var $title = $(this);
            var $body = $title.next(".c-accordion__body");
    
            if ($title.closest('.p-accordion___item').is(event.target)) {
                $body.slideDown(300); // 開く
                $title.addClass("open");
            } else {
                $body.slideUp(300); // 閉じる
                $title.removeClass("open");
            }
        });
    });
    

    

});

// ================================================================
// 該当セクションに入るときタブに黒線を追加
// ================================================================
document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll(".l-sec"); // 監視対象のセクション
    const tabLinks = document.querySelectorAll(".p-product-tab__link"); // ナビゲーションのリンク

    // 1. `.p-product-tab__link` の `href` から `#` を取り除き、対応するリンクをマッピング
    const linkMap = new Map();
    tabLinks.forEach(link => {
        const targetId = link.getAttribute("href").replace("#", ""); // `#` を削除
        if (targetId) {
            linkMap.set(targetId, link); // { "flow" => <a href="#flow"> }
        }
    });

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const sectionId = entry.target.id; // セクションの ID を取得

                // 2. `.p-product-tab__link` に `active` クラスを付与・削除
                tabLinks.forEach(link => link.classList.remove("section__active")); // すべてのリンクの `active` を削除
                if (linkMap.has(sectionId)) {
                    linkMap.get(sectionId).classList.add("section__active"); // 一致するリンクに `active` クラスを追加
                    console.log(`セクション ${sectionId} の対応するタブがアクティブになりました！`);
                }
            }
        });
    }, {
        root: null,  // ビューポート基準
        rootMargin: "-50% 0px -50% 0px", // セクションの上端が画面上部に達したら発火
        threshold: 0 // 1pxでも入ったら反応
    });

    // 3. `.l-sec` の要素を監視
    sections.forEach(section => observer.observe(section));
});





// ================================================================
// 375px以下でviewport変更
// ================================================================

!(function () {
    const viewport = document.querySelector('meta[name="viewport"]');
    function switchViewport() {
        const value =
            window.outerWidth > 375
                ? 'width=device-width,initial-scale=1'
                : 'width=375';
        if (viewport.getAttribute('content') !== value) {
            viewport.setAttribute('content', value);
        }
    }
    addEventListener('resize', switchViewport, false);
    switchViewport();
})();